import {
  API_RESPONSE_SUCCESS,
  API_RESPONSE_FAIL,
  GET_SPECIAL_DATES,
  ADD_SPECIAL_DATES,
  UPDATE_SPECIAL_DATES,
  DELETE_SPECIAL_DATES,
  GET_EXPORT_SPECIAL_DATES_SUCCESS,
  GET_EXPORTED_SPECIAL_DATES_FAIL,
  RESET_EXPORT_DATA
} from "./actionTypes"

const INIT_STATE = {
  specialDates: [],
  message: "",
  specialDatesError: {},
  file : ""
}

const SpecialDates = (state = INIT_STATE, action) => {
  switch (action.type) {
    case API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_SPECIAL_DATES:
          return {
            ...state,
            loading: false,
            specialDates: action.payload.data,
          }

        case ADD_SPECIAL_DATES:
          return {
            ...state,
            isSpecialDateCreated: true,
            message: action?.payload?.data.message || "",
          }

        case UPDATE_SPECIAL_DATES:
          return {
            ...state,
            isSpecialDateUpdated: true,
            message: action?.payload?.data.message || "",
          }

        case DELETE_SPECIAL_DATES:
          return {
            ...state,
            isSpecialDateDeleted: true,
            message: "Manage special dates removed successfully.",
          }

        default:
          return { ...state }
      }
    case API_RESPONSE_FAIL:
      switch (action.payload.actionType) {
        case GET_SPECIAL_DATES:
          return {
            ...state,
            loading: true,
            specialDatesError: action.payload.error,
          }

        case ADD_SPECIAL_DATES:
          return {
            ...state,
            specialDatesError: action.payload.error,
            isSpecialDateCreated: false,
          }

        case UPDATE_SPECIAL_DATES:
          return {
            ...state,
            specialDatesError: action.payload.error,
            isSpecialDateUpdated: false,
          }

        case DELETE_SPECIAL_DATES:
          return {
            ...state,
            specialDatesError: action.payload.error,
            isSpecialDateDeleted: false,
          }

        default:
          return { ...state }
      }

    case GET_SPECIAL_DATES:
      return {
        ...state,
        loading: true,
        isSpecialDateCreated: false,
        isSpecialDateDeleted: false,
        isSpecialDateUpdated: false,
      }

    case ADD_SPECIAL_DATES:
      return {
        ...state,
        isSpecialDateCreated: false,
      }

    case UPDATE_SPECIAL_DATES:
      return {
        ...state,
        isSpecialDateUpdated: false,
      }

    case DELETE_SPECIAL_DATES:
      return {
        ...state,
        isSpecialDateDeleted: false,
      }

      case GET_EXPORT_SPECIAL_DATES_SUCCESS:
        return {
          ...state,
          message: action.payload?.message,
          file: action.payload?.file,
          error: {},
        };
  
      case GET_EXPORTED_SPECIAL_DATES_FAIL:
        return {
          ...state,
          file: "",
          error: action.payload?.message || "Error occurred in export file.",
        };
  
      case RESET_EXPORT_DATA:
        return {
          ...state,
          error: {},
          message: "",
          file: "",
        };

    default:
      return state
  }
}

export default SpecialDates
